import { Route, Routes } from "react-router";
import { CatalogCreatePage } from "./pages/CatalogCreatePage";
import { CatalogEditPage } from "./pages/CatalogEditPage";
import { CatalogListPage } from "./pages/CatalogListPage";
import { PlaceReviewPage } from "./place/PlaceReviewPage";
import { SearchPage } from "./search/SearchPage";
import { UnsavedChangesScope } from "./unsaved";

/**
 * The catalog routes, mounted at `/catalog/*`:
 *   /catalog                the list        /catalog/new          create a draft
 *   /catalog/items/:id      the edit page   (the id is the item's catalog id)
 *   /catalog/places/review  the unresolved place matches (CHT-709)
 *   /catalog/search         staff search with scores and reasons (CHT-710)
 */
export function CatalogRoutes() {
  return (
    <UnsavedChangesScope>
      <Routes>
        <Route index element={<CatalogListPage />} />
        <Route path="new" element={<CatalogCreatePage />} />
        <Route path="items/:itemId" element={<CatalogEditPage />} />
        <Route path="places/review" element={<PlaceReviewPage />} />
        <Route path="search" element={<SearchPage />} />
      </Routes>
    </UnsavedChangesScope>
  );
}
